// data
const editModuleData = {
  show: false
};
// data - 经历库
const experience = {
  edus: [],
  works: [],
  orgs: [],
};

// 模块state
const moduleData = {
  profile: {}, // 基本信息模块
  edus: [], // 教育
  works: [], // 工作
  orgs: [], // orgs
};
// 页面使用常量state
const constData = {
  CONST_KIND: [ 'template', 'sample'], // kind常量
};
// faq系列
const faq = {
  faqOptions: [], // faq options
}


const state = () => ({
  ...constData, // 常量
  ...moduleData, // 模块数据
  ...faq,
  editModuleData, // 模块编辑传入子组件数据,
  experience, // 经历库
  cvToken: '',
  cvInfo: {}, // 简历详情
  sidebarOption: '', // 右侧栏目选中元素
  profile: '', // 基本信息模块
  list: [], // 新数据结构集合
  checkData: {}, // 检查元数据
  isGetData: true, // 是否请求模块数据
  onePage: () => {}, // 一页纸方法
  editModuleState:{
    state:false, //编辑状态
    type:'', //add,edit,module
  },
  mentor: false
})

export default state
